<template>
  <div class="card modal-overflow" style="box-shadow: none;">
    <div style="text-align: center">Loading {{ loadingProgress.loaded }} of {{ loadingProgress.total }} Invoices</div>
    <progress :value="loadingProgress.percent" style="width: 100%"></progress>
    <div style="text-align: center">
      <h6>{{ loadingProgress.message }}</h6>
    </div>
  </div>
</template>

<script>
import Progress from '@/components/UIComponents/Progress.vue'
import Constants from 'src/utilities/constants'

export default {
  props: ['data'],
  components: {
    Progress
  },
  computed: {
    loadingProgress() {
      return this.$store.get('invoices/create/loadingProgress')
    },
  },
  watch: {
    'loadingProgress.percent': {
      handler: function(progressPercent) {
        if (progressPercent === 100) {
          setTimeout(() => {
            this.$emit('close')
          }, Constants.TIME.MILLIS.ONE_SECOND)
        }
      }
    }
  }
}
</script>
